import { render, staticRenderFns } from "./update-event.vue?vue&type=template&id=681eac40"
import script from "./update-event.vue?vue&type=script&lang=js"
export * from "./update-event.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports